import React, { useEffect, useState } from "react";
import api, { FILE_BASE } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import EmptyState from "@/components/EmptyState";
import { dmY } from "@/lib/dateFmt";
import { UploadSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const fmt = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(n || 0);

export default function MyUploads() {
    const [uploads, setUploads] = useState([]);
    useEffect(() => { api.get("/uploads").then((r) => setUploads(r.data)); }, []);

    if (uploads.length === 0) {
        return (
            <div className="space-y-6">
                <h1 className="font-display text-4xl font-bold tracking-tight text-slate-900">Upload History</h1>
                <EmptyState
                    icon={UploadSimple}
                    title="No slips uploaded yet"
                    description="Your uploaded payment slips will appear here with verification status."
                    action={<Link to="/portal/upload"><Button className="mt-2 bg-blue-600 text-white hover:bg-blue-700">Upload a slip</Button></Link>}
                />
            </div>
        );
    }

    return (
        <div className="space-y-6" data-testid="my-uploads-page">
            <div>
                <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Portal</div>
                <h1 className="mt-1 font-display text-4xl font-bold tracking-tight text-slate-900">Upload History</h1>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {uploads.map((u) => (
                    <div key={u.id} data-testid={`my-upload-${u.id}`} className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
                        <a href={`${FILE_BASE}${u.file_url}`} target="_blank" rel="noreferrer">
                            <img
                                src={`${FILE_BASE}${u.file_url}`}
                                alt="slip"
                                className="h-40 w-full bg-slate-100 object-cover"
                                onError={(e) => { e.currentTarget.style.display = "none"; }}
                            />
                        </a>
                        <div className="space-y-2 p-4">
                            <div className="flex items-center justify-between">
                                <div className="font-display text-lg font-bold tabular-nums text-slate-900">{fmt(u.amount)}</div>
                                <StatusBadge status={u.status} />
                            </div>
                            <div className="text-xs text-slate-500">
                                <div>Date: <span className="text-slate-700">{dmY(u.payment_date)}</span></div>
                                <div>UTR: <span className="font-mono text-slate-700">{u.utr || "—"}</span></div>
                                <div>App: <span className="text-slate-700">{u.payment_app || "—"}</span></div>
                            </div>
                            {u.verification_notes && (
                                <div className="rounded-md bg-slate-50 px-2 py-1.5 text-xs text-slate-600">
                                    <span className="font-medium">Admin note:</span> {u.verification_notes}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
